import { render, staticRenderFns } from "./ServicesOverview.vue?vue&type=template&id=61286942&scoped=true"
import script from "./ServicesOverview.vue?vue&type=script&lang=js"
export * from "./ServicesOverview.vue?vue&type=script&lang=js"
import style0 from "./ServicesOverview.vue?vue&type=style&index=0&id=61286942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61286942",
  null
  
)

export default component.exports